import { render, staticRenderFns } from "./FooterSticky.vue?vue&type=template&id=3b844548"
import script from "./FooterSticky.vue?vue&type=script&lang=js"
export * from "./FooterSticky.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports